﻿import React from "react";
import { useParams } from "react-router-dom";
import { AssetCreateSettings } from "pages/asset/shared";
import { useQuery } from "hooks/useQuery";


export function AssetCreate(props) {

    const { businessArea } = useParams();
    const query = useQuery();
    const area = query.get("area");

    function getBreadcrumbs() {
        if (area === "MMF") return [{ location: '/fleet/manage', title: "Fleet Planner" }, { title: "Add Asset" }];
        if (businessArea === "2") return [{ location: `${window.env.VISION_URL}/#/Fleet`, title: "Maintenance Overview", externalLink: true }, { title: "Add Asset" }];
        if (!area && !businessArea) return [{ location: '/asset/manage', title: "Manage Assets" }, { title: "Add Asset" }];
        return props.breadcrumbs ?? [{ location: '/asset/manage', title: "Manage Assets" }, { title: "Add Asset" }];
    }

    return (
        <AssetCreateSettings breadcrumbs={getBreadcrumbs()} businessArea={businessArea} area={area != null ? area : "MMV"}/>
    );
}